import BaseLog, { LogType } from "./base_log";

export default class VIPStat extends BaseLog {
    constructor(common: object, logUrl: string, isDebug: boolean) {
        super(common, logUrl, isDebug);
    }

    updateCommon(common: object) {
        Object.assign(this.common, common);
    }
    /**
  * @Desc   record toast log
  * @Params params log message
  * @Return
 */
    toast(params: object) {
        this.save({
            lt: LogType.toast,
            ...params,
        });
    }
    /**
   * @Desc   record error log
   * @Params params log message
   * @Return
  */
    error(params: object) {
        this.save({
            lt: LogType.error,
            ...params,
        });
    }
    /**
   * @Desc   record event log
   * @Params params log message
   * @Return
  */
    event(params: object) {
        this.save({
            lt: LogType.event,
            ...params,
        });
    }
    /**
   * @Desc   record pageView log
   * @Params params log message
   * @Return
  */
    pageview(params: object) {
        this.save({
            lt: LogType.pageView,
            ...params,
        });
    }
    /**
   * @Desc   record network log
   * @Params params log message
   * @Return
  */
    network(params: object) {
        this.save({
            lt: LogType.network,
            ...params,
        })
    }
}
